"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lookupAllPrefixes = void 0;
const fetchContext_1 = require("./fetchContext");
/**
 * Use prefix.cc to look up all recorded prefixes
 */
function lookupAllPrefixes(options) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, fetchContext_1.fetchContext)('https://prefix.cc/context', options);
    });
}
exports.lookupAllPrefixes = lookupAllPrefixes;
